<template>
    <AppLayout>
        <ResetPasswordForm />
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/components/layouts/AppLayout.vue';
import ResetPasswordForm from '@/components/pages/Auth/ResetPasswordForm.vue';
</script>
